import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { Table, Button, Select, Modal } from "antd";
import UserPortfolioManager from "./UserPortfolioManager";
import UserAppManager from "./UserAppManager";
const { Option } = Select;

const SuperUsersTable = ({ userList }) => {
  const dispatch = useDispatch();
  // State to manage the visibility and selected user for UserPortfolioManager
  const [isPortfolioManagerVisible, setIsPortfolioManagerVisible] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);

  // New state for UserAppManager
  const [isAppManagerVisible, setIsAppManagerVisible] = useState(false);
  const [selectedUserApps, setSelectedUserApps] = useState([]);

  const handleAccountTypeChange = (userId, acctType) => {
    console.log(`Changing account type for ${userId} to ${acctType}`);
    // Dispatch action to update user account type
  };

  const handleLoadPortfolios = (userId) => {
    setSelectedUserId(userId);
    setIsPortfolioManagerVisible(true);
  };

  const handleClosePortfolioManager = () => {
    setIsPortfolioManagerVisible(false);
    setSelectedUserId(null);
  };

  // New handler for opening UserAppManager
  const handleOpenAppManager = (record) => {
    console.log(record);
    setSelectedUserApps(record?.settings?._app_whitelist);
    setSelectedUserId(record.uid);
    setIsAppManagerVisible(true);
  };

  const handleCloseAppManager = () => {
    setIsAppManagerVisible(false);
  };

  const columns = [
    {
      title: 'Username',
      dataIndex: ['auth', 'username'],
      key: 'username',
    },
    {
      title: 'Account Type',
      key: 'acctType',
      render: (_, record) => (
        <Select defaultValue={record.auth?.acct_type} style={{ width: 120 }} onChange={(value) => handleAccountTypeChange(record.uid, value)}>
          <Option value="tracker">Tracker</Option>
          <Option value="admin">Admin</Option>
          <Option value="user">User</Option>
        </Select>
      ),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <>
          <Button onClick={() => handleLoadPortfolios(record.uid)} style={{ marginRight: 8 }}>Load Portfolios</Button>
          <Button onClick={() => handleOpenAppManager(record)}>Manage Apps</Button>
        </>
      ),
    },
  ];

  return (
    <>
      <Table columns={columns} dataSource={userList} rowKey="uid" />
      {selectedUserId && (
        <UserPortfolioManager
          userId={selectedUserId}
          visible={isPortfolioManagerVisible}
          onClose={handleClosePortfolioManager}
        />
      )}
      {isAppManagerVisible && (
        <Modal
          title="Manage User Applications"
          visible={isAppManagerVisible}
          onCancel={handleCloseAppManager}
          footer={null}
          width={800}
        >
          <UserAppManager userId={selectedUserId} userAppKeys={selectedUserApps} />
        </Modal>
      )}
    </>
  );
};

export default SuperUsersTable;
